/** Visually hidden; keeps label in the accessibility tree (e.g. htmlFor + checkbox id). */
export const screenReaderOnlyLabelSx = {
  position: 'absolute',
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  border: 0,
} as const;
